import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { RxCalendar } from "react-icons/rx";
import { AuthContext } from "../../../contexts/AuthContext";
import { handleCountBookings } from "../../../apis/bookings";

export default function ConfirmedWidget() {
  const { site } = useContext(AuthContext);

  const { data: count } = useQuery({
    queryKey: ["confirmedCount", site?._id],
    queryFn: () =>
      handleCountBookings({
        site: site?._id === 0 ? "" : site?._id,
        isConfirmed: 1,
        isFulfilled: "",
      }),
  });

  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-3 border p-2 border-gray-300 bg-green-100">
      <div className="flex">
        <div className="flex justify-center items-center w-14 h-14 bg-green-200 border border-green-300">
          <RxCalendar size={34} />
        </div>
        <div className="flex flex-col border-l border-green-300 pl-2 ml-2">
          <div className="uppercase">Confirmed Bookings</div>
          <div className="font-bold text-2xl">{count}</div>
        </div>
      </div>
    </div>
  );
}
